import { Box, Container, Divider, Heading } from '@chakra-ui/react';
import CustomStepper from 'components/ui/custom-stepper/CustomStepper';
import StepperProvider from 'components/ui/custom-stepper/CustomStepperContext';
import HeaderBarInternal from 'components/ui/HeaderBarInternal';
import { wrapperDialogDefaultProps } from 'features/emails/config';
import { useResource } from 'hooks/useResource';
import { useParams } from 'react-router-dom';
import FormNote from '../forms/FormNote';

export default function PageCreateNote() {
  const { contentGroupId } = useParams() as { contentGroupId: string };
  const { data: contentGroup } = useResource({ id: contentGroupId, resourceName: 'contentGroup', path: 'content-groups' });  

  return (
    <StepperProvider
      steps={['Dados da nota', 'Tópicos da nota']}
      activeStepIndex={0}
    >
      <Box pb="100px" minH="850px">
        <HeaderBarInternal
          title="Criar nota"
          backTo="/notas-de-agenda"
          dialogProps={wrapperDialogDefaultProps}
        >
          <CustomStepper />
        </HeaderBarInternal>
        <Divider />

        <Container 
          variant="internal"
          flexDirection="column"
          minH="800px"
        >
          <Heading as="h1" size="h1">
            Dados da nota
            <span>Insira os dados da nova nota</span>
          </Heading>

          { contentGroup && <FormNote contentGroup={contentGroup} /> }
        </Container>
      </Box>
    </StepperProvider>
  )
}